export default {
    GET_ALL_PROVIDER: 'GET_ALL_PROVIDER',
    ADD_PROVIDER: 'ADD_PROVIDER',
    UPDATE_PROVIDER: 'UPDATE_PROVIDER',
    DELETE_PROVIDER: 'DELETE_PROVIDER',
    CHANGE_ACTIVATION_PROVIDER: 'CHANGE_ACTIVATION_PROVIDER',
}